export const SESSION_EXPIRED_EVENT = new Event('SESSION_EXPIRED')
